<!--
 * @Author: your name
 * @Date: 2020-08-13 20:29:51
 * @LastEditTime: 2020-09-26 08:50:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pay/component/Items/index.vue
-->
<style scoped lang="sass">
.items
  flex-shrink: 0
  display: flex
  justify-content: space-between
  padding: 14px 0
  border-bottom: 1px solid #f1f2f3
  min-height: 68px
  padding-left: 17px
  padding-right: 17px

  .left
    padding-right: 12px
    font-size: 13px
    line-height: 16px
    font-weight: bold
    color: var(--menu-primary-text-colour) !important

    .num
      line-height: 19px

  .mid
    flex: 1
    display: flex
    flex-direction: column

    .title
      font-size: 13px
      color: var(--menu-primary-text-colour) !important

    .detail
      color: var(--menu-primary-text-colour) !important
      font-size: 12px

  .right
    display: flex
    justify-content: space-between
    flex-direction: column
    font-size: 12px
    color: var(--menu-primary-text-colour) !important

    .money
      text-align: right
.normal_font
  line-height: 17px
</style>

<template lang="pug">
.items
  .left {{ data.no }}
  .mid
    .title.b {{ data.name }} {{ data.selectSize && data.selectSize.name ? `(${data.selectSize.name})` : '' }}
    .detail
      .required(v-if="data.addList")
        .normal_font(v-for="(items, i) in data.addList" :key="items.id")
          span(v-if="items.type !== 'optional'" v-for="(each, eachIndex) in items.items" :key="each.id")
            span.o5(v-if="!eachIndex") {{ each.name }}{{ each.no > 1 ? ' x' + each.no : '' }}
            span.o5(v-if="eachIndex") {{ ', ' + each.name }}{{ each.no > 1 ? ' x' + each.no : '' }}
      .normal_font(v-for="(item, i) in data.addList" :key="data.id + i" v-if="item.type==='optional'")
        span(v-for="(each, index) in item.items" :key="each.id")
          span.o5(v-if="!index") {{ 'Add: '}}
          span.o5(v-if="index") {{ ", " }}
          span.o5 {{ each.name }}{{ each.no > 1 ? ' x' + each.no : '' }}
      .normal_font(v-for="(item, i) in data.removeList" :key="data.id" v-if="item.type==='optional' || 'required'")
        span(v-for="(each, index) in item.items" :key="each.id")
          span.o5(v-if="!index") {{ 'Remove: '}}
          span.o5(v-if="index") {{ ", " }}
          span.o5 {{ each.name }}{{ each.no > 1 ? ' x' + each.no : '' }}
  .right
    .money.o {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ data.amount | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
    status(v-if="isPostPaid && $route.name === 'pay'" :number="data.status")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './../Status'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  filters: {
    fix(val) {
      return val ? formatDecimalNumber(parseFloat(val)) : 0
    }
  },
  props: {
    data: Object,
    isPostPaid: Boolean
  },
  components: {
    Status
  },
  computed: {
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})
class Items extends Vue {
}

export default Items
</script>
